import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "form-block radio-field" }
const _hoisted_2 = { for: "" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { for: "customRadioInline1" }
const _hoisted_6 = {
  key: 2,
  class: "action-button"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  "data-toggle": "modal",
  "data-target": "#editradio"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
], -1)
const _hoisted_9 = { class: "modal-wrap form-edit" }
const _hoisted_10 = {
  class: "modal fade",
  id: "editradio",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_11 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Edit form"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_14 = { class: "modal-body" }
const _hoisted_15 = { class: "form-wrap pt-0" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Label", -1)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"form-group\"><label for=\"inputPassword\">Options</label><div class=\"row\"><div class=\"col-lg-1\"><div class=\"form-check custom-control custom-radio\"><input class=\"custom-control-input\" type=\"radio\" name=\"exampleRadios\" id=\"exampleRadios1\" value=\"option1\" checked><label class=\"custom-control-label\" for=\"exampleRadios1\"></label></div></div><div class=\"col-lg-5\"><input type=\"text\" class=\"form-control\" placeholder=\"Option label\"></div><div class=\"col-lg-5\"><input type=\"text\" class=\"form-control\" placeholder=\"Option value\"></div><div class=\"col-lg-1 pl-0\"><button type=\"button\" class=\"option-btn\"><i class=\"fas fa-times\"></i></button></div></div><a href=\"javascript:void(0)\" class=\"btn default-btn outline secondary mt-3 float-right\"><i class=\"fas fa-plus\"></i> Add option</a></div>", 1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn default-btn"
  }, " Save changes "),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn secondary-btn",
    "data-dismiss": "modal"
  }, " Close ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.data.title), 1),
      (_ctx.data.select_values)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.select_values, (option, optionIndex) => {
              return (_openBlock(), _createBlock("div", {
                class: "custom-control custom-radio custom-control-inline",
                key: optionIndex
              }, [
                _withDirectives(_createVNode("input", {
                  type: "radio",
                  id: `customRadioInline${_ctx.index}`,
                  name: `customRadioInline${_ctx.index}`,
                  class: "custom-control-input",
                  value: option.value,
                  "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                }, null, 8, ["id", "name", "value", "onUpdate:modelValue"]), [
                  [_vModelRadio, option.selected]
                ]),
                _createVNode("label", {
                  class: "custom-control-label",
                  for: `customRadioInline${_ctx.index}`
                }, _toDisplayString(option.text), 9, ["for"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.data.options)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.options, (option, optionIndex) => {
              return (_openBlock(), _createBlock("div", {
                class: "custom-control custom-radio custom-control-inline",
                key: optionIndex
              }, [
                _withDirectives(_createVNode("input", {
                  type: "radio",
                  id: `customRadioInline${_ctx.index}`,
                  name: `customRadioInline${_ctx.index}`,
                  value: option.option,
                  "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                }, null, 8, ["id", "name", "value", "onUpdate:modelValue"]), [
                  [_vModelRadio, option.selected]
                ]),
                _createVNode("label", _hoisted_5, _toDisplayString(option.option), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.editStatus)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "inputPassword",
                    placeholder: "Text field label",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.title = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.title]
                  ])
                ]),
                _hoisted_18
              ])
            ]),
            _hoisted_19
          ])
        ])
      ])
    ])
  ]))
}